import Box from '@mui/material/Box';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetDefaultQuery } from '../../apiRtk/be4feApi';
import commonActions, { selectors } from '../../modules/common';
import { tryCheckActiveFeatureFlags, tryCheckAppVersion } from './appHealthCheck';

export function AppHeartBeat() {
  const isVersionWarningDisplayed = useSelector(selectors.isSiteVersionWarningDisplayed);
  const closedBannerMessage = useSelector(selectors.getClosedBannerMessage);
  const featureFlags = useSelector(selectors.getGlobalFeatures);
  const dispatch = useDispatch();

  const {
    data: defaultBannerData,
    isFetching: isBannerDataFetching,
    refetch: refetchBannerData,
  } = useGetDefaultQuery();

  useEffect(() => {
    const interval = setInterval(
      () => {
        if (process.env.NODE_ENV !== 'development' && !isVersionWarningDisplayed) {
          tryCheckAppVersion(() => dispatch(commonActions.siteVersionWarningShow()));

          tryCheckActiveFeatureFlags(featureFlags, () => dispatch(commonActions.siteVersionWarningShow()));
        }

        if (!isBannerDataFetching) {
          refetchBannerData();
        }
      },
      parseInt(process.env.APP_HEARTBEAT_INTERVAL ?? '180000')
    );
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (defaultBannerData?.message && defaultBannerData.title + defaultBannerData.message !== closedBannerMessage) {
      dispatch(commonActions.maintenanceBannerShow(defaultBannerData));
    }
  }, [defaultBannerData]);

  return <Box />;
}
